export class Sprite2DGeometry {
    constructor(stride, vballoc, iballoc) {
        this._stride = 0;
        this._vertNum = 0;
        this._indexNum = 0;
        this._stride = stride;
        this._VBBuff = new ArrayBuffer(vballoc || 32);
        this._IBBuff = new ArrayBuffer(iballoc || 8);
        this.onVBRealloc(this._VBBuff);
        this.onIBRealloc(this._IBBuff);
    }
    get vbBuffer() {
        return this._VBBuff;
    }
    get ibBuffer() {
        return this._IBBuff;
    }
    get indexNum() {
        return this._indexNum;
    }
    get vertexNum() {
        return this._vertNum;
    }
    clearMesh() {
        this._vertNum = 0;
        this._indexNum = 0;
    }
    expVBSize(len) {
        if (len) {
            let curLen = this._vertNum * this._stride;
            if (curLen + len > this._VBBuff.byteLength) {
                let old = this._VBBuff;
                this._VBBuff = new ArrayBuffer(curLen + len * 8);
                (new Uint8Array(this._VBBuff, 0, curLen)).set(new Uint8Array(old, 0, curLen));
                this.onVBRealloc(this._VBBuff);
            }
        }
    }
    expIBSize(len) {
        if (len) {
            let curlen = this._indexNum * 2;
            if (curlen + len > this._IBBuff.byteLength) {
                let old = this._IBBuff;
                this._IBBuff = new ArrayBuffer(curlen + len * 8);
                (new Uint8Array(this._IBBuff, 0, curlen)).set(new Uint8Array(old, 0, curlen));
                this.onIBRealloc(this._IBBuff);
            }
        }
    }
}
